<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chaptertitle1">Contents</h2>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc"><a href="#/chap1">Stories from History</a></p>
<p class="toc"><span href="#/chap2" title="Link target outside of Sample">Stories from Headlines</span></p>
<p class="toc"><span href="#/chap3" title="Link target outside of Sample">Stories from Homefolks</span></p>
<p class="toc"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/visit" title="Link target outside of Sample">Places to Visit</span></p>
<p class="toc"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/abt" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?29b9ac12